import ProgressBar from 'common/components/ProgressBar'
import { formatNumber } from 'common/helpers/numeric'
import { Spinner } from 'common/icons'

import useGetUMVUsageQuery from '../api/queries/useGetUMVUsageQuery'

const calculateProgress = ({
  used,
  limit,
}: {
  used: number
  limit: number
}): number => {
  if (limit === 0) {
    return 0
  }
  return Math.ceil((used / limit) * 100)
}

const UMVProgressBar = () => {
  const { data: umvData, isLoading } = useGetUMVUsageQuery()
  const { umvLimit, umvUsed = 0 } = umvData || {}

  if (umvLimit === undefined) {
    return null
  }

  const progress = calculateProgress({ used: umvUsed, limit: umvLimit })

  const umvUsageContent = isLoading ? (
    <Spinner isDefaultColor={false} className="animate-spin mr-1" size={4} />
  ) : (
    `${formatNumber(umvUsed)} / ${formatNumber(umvLimit)}`
  )

  return (
    <div className="flex flex-col gap-1">
      <div className="py-1">
        <ProgressBar progress={progress} />
      </div>
      <div className="flex items-center text-xs text-white">
        {umvUsageContent} UMV's used
      </div>
    </div>
  )
}

export default UMVProgressBar
